import styled from 'styled-components';
export const DropDownListStyled = styled.div`
  .shell-select-container-selector {
    outline:none;
  }
  .shell-select-container-disabled{
    opacity:0.32;
  }
  .shell-select-container-selection-search-input{
    border-radius:2px;
    width:100%;
    height:100%;
  }
  .shell-select-container-selection-item{
    background:rgba(30,36,43,1) !important;
    border-radius:2px;
  }
`;
